/**
 * WebSocket event types.
 * These match the WebsocketEventType enum defined in the backend DTOs
 * and exposed via the OpenAPI spec.
 */
export var WebsocketEventType;
(function (WebsocketEventType) {
    WebsocketEventType["GroupCreated"] = "group.created";
    WebsocketEventType["GroupUpdated"] = "group.updated";
    WebsocketEventType["GroupDeleted"] = "group.deleted";
    WebsocketEventType["ReminderCreated"] = "reminder.created";
    WebsocketEventType["ReminderUpdated"] = "reminder.updated";
    WebsocketEventType["ReminderDeleted"] = "reminder.deleted";
    WebsocketEventType["ReminderEventCreated"] = "reminder-event.created";
    WebsocketEventType["TaskCreated"] = "task.created";
    WebsocketEventType["TaskUpdated"] = "task.updated";
    WebsocketEventType["TaskDeleted"] = "task.deleted";
    WebsocketEventType["JournalEntryCreated"] = "journal-entry.created";
    WebsocketEventType["JournalEntryUpdated"] = "journal-entry.updated";
    WebsocketEventType["JournalEntryDeleted"] = "journal-entry.deleted";
    WebsocketEventType["EventCreated"] = "event.created";
    WebsocketEventType["UserProfileUpdated"] = "user.profile-updated";
})(WebsocketEventType || (WebsocketEventType = {}));
